// eslint-disable-next-line import/prefer-default-export
export const LabelPosition = Object.freeze({
  Top: 'top',
  Left: 'left',
});
